export default __webpack_public_path__ + "static/img-nhs-process-e30dc3f5317c9b0962ae988d5e104434.webp";